import { useState } from "react";
import api from "../api/axios";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import logo from "./asset/LOGO-CLIMATISATION-LS.png"
export default function Login() {
  const [email, setEmail] = useState("");
  const [mot_de_passe, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 🔒 Sécurité basique
    if (!email || !mot_de_passe) {
      setError("⚠️ Veuillez remplir tous les champs");
      return;
    }

    setError("");
    setLoading(true);

    try {
      console.log({
 email,
 mot_de_passe
});
      const res = await api.post(
      "/auth/login",
        {
          email,
          mot_de_passe,
        },
        { withCredentials: true }
      );

      // ✅ Sauvegarde session
      login(res.data);

      // 🔁 Redirection selon rôle
      if (res.data.user.role === "ADMIN") {
        navigate("/admin", { replace: true });
      } else {
        navigate("/technicien", { replace: true });
      }

    } catch (err) {
      if (err.response?.status === 401) {
        setError("❌ Email ou mot de passe incorrect");
      } else if (err.code === "ECONNABORTED") {
        setError("⏳ Serveur indisponible");
      } else {
        setError("⚠️ Erreur serveur, réessayez");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <img src={logo} alt="Logo" className="login-logo" />
        <h2>Connexion</h2>
      

        {error && <div className="login-error">{error}</div>}

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={loading}
          required
        />

        <input
          type="password"
          placeholder="Mot de passe"
          value={mot_de_passe}
          onChange={(e) => setPassword(e.target.value)}
          disabled={loading}
          required
        />

        <button type="submit" disabled={loading}>
          {loading ? "Connexion..." : "Se connecter"}
        </button>
      </form>
    </div>
  );
}
